import Badge from 'components/shared/Badge/Badge';
import Disclosure from 'components/shared/Disclosure/Disclosure';
import Typography from 'components/shared/Typography/Typography';

const cardOnFileOptions = [
  {
    title: 'Give patient the option',
    caption:
      'Patients may opt in to card-on-file during check-in. Highest consent rate and patient satisfaction.',
    value: 'patient-option',
    recommended: true
  },
  {
    title: 'Require card on file',
    caption: 'Require card on file',
    value: 'require-card-on-file',
    recommended: false
  }
];

const CardOnFile = ({ value, onChange }) => {
  return (
    <div className="flex flex-col gap-1.5">
      <Typography variant="p" size="small">
        Card on file
      </Typography>
      {cardOnFileOptions.map((option) => {
        const isActive = option.value === value;
        return (
          <Disclosure
            key={option.value}
            isOpen={isActive}
            onToggle={() => onChange(option.value)}
            customTitle={
              <div className="flex gap-2">
                <Typography variant="p" size="small" weight="medium">
                  {option.title}
                </Typography>
                {option.recommended && (
                  <Badge text="Recommended" variant="lighter" color="primary" size="small" />
                )}
              </div>
            }
            disableOpen
            caption={option.caption}
            className="w-full"
            buttonClassName="py-2"
            bodyClassName="flex-col gap-0"
            radio
          />
        );
      })}
    </div>
  );
};

export default CardOnFile;
